module.exports = __webpack_public_path__ + "img/ic_rib_violet.76a9da38.svg";